module.exports = __webpack_public_path__ + "static/media/method-banner.ee51294e.png";